var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "select-object",
          class: { "highlighted-box": _vm.badObject },
          style: {
            border: _vm.getColorForBorder(_vm.state),
            "background-color": _vm.getColorForBackgroundColor(_vm.state),
            "box-shadow": _vm.getColorForBoxShadow(_vm.state),
            color: _vm.getColorForText(_vm.state)
          }
        },
        [
          _vm._v("\n  " + _vm._s(_vm.message) + "\n  "),
          _vm.loading
            ? _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 17,
                  width: 2
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66795759", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66795759","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Molecules/HighlightedBox.vue
// module id = null
// module chunks = 